<template>
  <div class="footer-steps mt" v-if="timelineItems.length > 0 && timelineItems[0].IconPath">
    <h3>Wat gaat er nu gebeuren</h3>
    <div class="layout layout--auto pt-">
      <div
        class="layout__item u-1/1-palm"
        v-for="item in timelineItems"
        :key="item.Title"
        v-tooltip="`${item.Description}`"
      >
        <div class="footer-steps__icon" :style="`background-image:url('${item.IconPath}')`"></div>
        <div class="footer-steps__text">
          <p v-html="item.Title"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		timelineItems: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style>
</style>
